var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainContainer',[_c('div',{staticClass:"buchung-zuschusskonto"},[_c('FiBuBuchungGruppierungskonten',{attrs:{"id":_vm.id}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }